import { agentProfileIdSchema, openMeldRuntimeProfileIdSchema, profileKindSchema, uuidProfileIdSchema } from "../protocol/profile.js";
import { spaceNameSchema } from "./space-name.js";
import { spaceAccessModeSchema, spaceLinkJoinPolicySchema } from "./space-access-mode.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/space-meta.ts
const trimmedNonEmptyStringSchema = z$1.string().trim().min(1);
const isoDateTimeSchema = z$1.iso.datetime({ offset: true });
const MAX_SPACE_GUIDE_LENGTH = 4e3;
const spaceOrganizationVisibilitySchema = z$1.enum(["public", "private"]);
function resolveInitialSpaceAccessMode(_visibility) {
	return "members_only";
}
const spaceCreatorSchema = z$1.strictObject({
	profileId: openMeldRuntimeProfileIdSchema,
	profileName: trimmedNonEmptyStringSchema.optional(),
	kind: profileKindSchema.optional(),
	profile: trimmedNonEmptyStringSchema.optional(),
	ownerUserId: trimmedNonEmptyStringSchema.optional(),
	ownerName: trimmedNonEmptyStringSchema.optional()
}).superRefine((value, ctx) => {
	if (!value.kind) return;
	if ((value.kind === "agent" ? agentProfileIdSchema : uuidProfileIdSchema).safeParse(value.profileId).success) return;
	ctx.addIssue({
		code: "custom",
		message: value.kind === "agent" ? "agent profileId must use agt_<UUID>" : "human/system profileId must be a UUID",
		path: ["profileId"]
	});
});
const spaceStorageUsageSchema = z$1.strictObject({
	usedBytes: z$1.number().finite().min(0),
	softLimitBytes: z$1.number().finite().positive(),
	usagePercent: z$1.number().finite().min(0)
});
const spaceDirectMessageMetaSchema = z$1.strictObject({
	convertedAt: isoDateTimeSchema.optional(),
	pairKey: trimmedNonEmptyStringSchema
});
const spaceMetaSchema = z$1.strictObject({
	spaceId: trimmedNonEmptyStringSchema,
	organizationId: trimmedNonEmptyStringSchema,
	visibility: spaceOrganizationVisibilitySchema,
	name: trimmedNonEmptyStringSchema.optional(),
	purpose: trimmedNonEmptyStringSchema.optional(),
	directMessage: spaceDirectMessageMetaSchema.optional(),
	creator: spaceCreatorSchema.optional(),
	ownerUserIds: z$1.array(trimmedNonEmptyStringSchema).optional(),
	allowGuests: z$1.boolean().optional(),
	guide: trimmedNonEmptyStringSchema.optional(),
	accessMode: spaceAccessModeSchema.optional(),
	linkJoinPolicy: spaceLinkJoinPolicySchema.optional(),
	passwordProtected: z$1.boolean().optional(),
	createdAt: isoDateTimeSchema.optional(),
	updatedAt: isoDateTimeSchema.optional(),
	storageUsage: spaceStorageUsageSchema.optional()
});
const patchSpaceMetaResponseSchema = spaceMetaSchema;
const getSpaceMetaResponseSchema = spaceMetaSchema;
const patchSpaceMetaBodySchema = z$1.strictObject({
	visibility: spaceOrganizationVisibilitySchema.optional(),
	allowGuests: z$1.boolean().optional(),
	ownership: z$1.strictObject({
		userId: trimmedNonEmptyStringSchema,
		role: z$1.enum(["owner", "member"])
	}).optional(),
	name: spaceNameSchema.optional(),
	purpose: z$1.string().optional(),
	guide: z$1.string().max(MAX_SPACE_GUIDE_LENGTH).optional()
}).superRefine((value, ctx) => {
	if (value.ownership !== void 0 || value.allowGuests !== void 0 || value.name !== void 0 || value.visibility !== void 0 || value.purpose !== void 0 || value.guide !== void 0) return;
	ctx.addIssue({
		code: "custom",
		message: "Expected name, purpose, guide or visibility"
	});
}).transform((value) => ({
	...value.allowGuests === void 0 ? {} : { allowGuests: value.allowGuests },
	...value.ownership === void 0 ? {} : { ownership: value.ownership },
	...value.visibility === void 0 ? {} : { visibility: value.visibility },
	...value.name === void 0 ? {} : { name: value.name },
	...value.purpose === void 0 ? {} : { purpose: value.purpose },
	...value.guide === void 0 ? {} : { guide: value.guide }
}));
//#endregion
export { MAX_SPACE_GUIDE_LENGTH, getSpaceMetaResponseSchema, patchSpaceMetaBodySchema, patchSpaceMetaResponseSchema, resolveInitialSpaceAccessMode, spaceCreatorSchema, spaceDirectMessageMetaSchema, spaceMetaSchema, spaceOrganizationVisibilitySchema, spaceStorageUsageSchema };

//# sourceMappingURL=space-meta.js.map